import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import { observer } from 'mobx-react';

const BaseballMatchGameBoxScore = observer(({ item }) => {
  const {
    getTracker,
    period,
    sortedAwayScores,
    sortedHomeScores,
    teams
  } = item;
  const { home, away } = teams;
  const [inningArr, setInningArr] = useState([1, 2, 3, 4, 5, 6, 7, 8, 9]);
  const [isOverView, setOverView] = useState(false);
  const homeTotalScore = sortedHomeScores.reduce((a, b) => a + b.score, 0);
  const awayTotalScore = sortedAwayScores.reduce((a, b) => a + b.score, 0);

  useEffect(() => {
    if (period > 9) {
      const arr = new Array(period)
        .fill(1)
        .map((item, idx) => item * (idx + 1));

      setInningArr(arr);
      setOverView(true);
    } else {
      setInningArr([1, 2, 3, 4, 5, 6, 7, 8, 9]);
      setOverView(false);
    }
  }, [period]);

  return (
    <div className={clsx('basic_board', isOverView && 'overtime')}>
      {/* 클래스 : overtime */}
      <div className="inner">
        {inningArr.map((inning, idx) => {
          return (
            <dl
              className={clsx(
                'item',
                getTracker.status === 'progress' && period === inning && 'on'
              )}
              key={`box-item-${inning}`}
            >
              <dt>{inning}</dt>
              <dd>{!!sortedAwayScores[idx] && sortedAwayScores[idx].score}</dd>
              <dd>{!!sortedHomeScores[idx] && sortedHomeScores[idx].score}</dd>
            </dl>
          );
        })}
      </div>
      <dl className="item r">
        <dt>R</dt>
        <dd>{awayTotalScore}</dd>
        <dd>{homeTotalScore}</dd>
      </dl>
      <dl className="item">
        <dt>H</dt>
        <dd>{away.hitCount}</dd>
        <dd>{home.hitCount}</dd>
      </dl>
      <dl className="item">
        <dt>E</dt>
        <dd>{away.errorCount}</dd>
        <dd>{home.errorCount}</dd>
      </dl>
      <dl className="item">
        <dt>B</dt>
        <dd>{away.baseOnBallCount}</dd>
        <dd>{home.baseOnBallCount}</dd>
      </dl>
    </div>
  );
});

export default BaseballMatchGameBoxScore;
